var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:("actions-" + _vm.rowIndex),staticClass:"action-buttons"},[_c('div',{staticClass:"p-2"},[(_vm.buttonsLoading)?_c('action-button-skeleton'):(_vm.hasButtons)?_c('expanded-row-buttons',{attrs:{"row-id":_vm.rowId}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }